export const environment = {
  production: true,
  authServiceUrl: 'https://auth.zikata.africa/auth',
  authRealm: 'client',
  authClientId: 'clients-dev',
  authSuccessRedirectUrl: 'https://backend.zikata.africa',
  officerRoles: {
    ROLE_CLIENT: 'Client',
  },
  apiGatewayBaseUrl: 'https://backend.zikata.africa/api/v1',
  apiGatewayV2BaseUrl: 'https://backend.zikata.africa/api/v2',
  fbAccessToken: 'EAA9ywGKsAQ0BSMqdXqt9SM8B5AwyyBuuOPNlIJczSOQy3GEcrTGmFZAO4qPubaNAULGsErbooItaHpzPKZA4KPvdPTdV1FYHEcfGrIXY4MTsBRywQGFZAuOpSpKxsJTTzWH6KoFJCreOO4UD6NMMLf0wplRIBhX0lFSgpUJza0PrWl85sqZA2TpaVP3OZBgZDZD',
  phoneNumberId: '1165264163345035',
};